import BaseProjectResponse from '@/api/Main/dataSource/api/projects/base/i-service/models/BaseProjectResponse';
import ProjectGetBuIdRequest from '@/api/Main/dataSource/api/projects/base/i-service/models/ProjectGetBuIdRequest';
import { UserModel } from '@/components/task-forms/models';
import { ProjectModel } from '@/models';
import { CheckEstimateRequestModel, CheckEstimateResponseModel } from '../models';

export const mapGetProjectRequest = (projectId: number) =>
  new ProjectGetBuIdRequest({
    ProjectId: projectId,
  });

export const mapGetProjectResponse = (response: BaseProjectResponse) =>
  new ProjectModel({
    Id: response.Id,
    Name: response.Name,
    ImageUrl: response.ImageUrl,
    PreviewColor: response.PreviewColor,
    WeekEnable: response.WeeekEnable,
    Admins: response.Admins.map(
      (x) =>
        new UserModel({
          Id: x.UserId,
          FirstName: x.FirstName,
          MiddleName: x.MiddleName,
          LastName: x.LastName,
          ImageUrl: x.Foto,
          AvatarColor: x.AvatarColor,
        }),
    ),
  });

export const mapCheckInviteToEstimateRequest = (taskId: number) => {
  return new CheckEstimateRequestModel({
    TaskId: taskId,
  });
};

export const mapCheckInviteToEstimateResponse = (response: CheckEstimateResponseModel) => {
  return new CheckEstimateResponseModel({
    Invite: response.Invite,
  });
};
